import React from 'react';
import PropTypes from 'prop-types';
import {BOTTOM, TOP} from 'common/constants';
import {getLinearGradient} from 'common/utils/style-util';
import './index.scss';

export default class StoryboardScrollHint extends React.Component {
  static propTypes = {
    height: PropTypes.number,
    opacity: PropTypes.number,
    position: PropTypes.oneOf([BOTTOM, TOP]),
  };

  static defaultProps = {
    height: 50,
    opacity: 0,
    position: BOTTOM,
  };

  getAlpha(opacity) {
    // 0.15 is the max alpha percentage permitted,
    // opacity is a percentage of 0.15.
    return 0.15 * opacity;
  }

  getBackground(position, alpha) {
    switch (position) {
      case TOP:
        return getLinearGradient([
          `rgba(0, 0, 0, ${alpha})`,
          'rgba(0, 0, 0, 0)',
        ]);
      default:
        return getLinearGradient([
          'rgba(0, 0, 0, 0)',
          `rgba(0, 0, 0, ${alpha})`,
        ]);
    }
  }

  getStyle(position, height, background) {
    const style = {
      background,
      height,
    };
    style[position] = 0;
    return style;
  }

  render() {
    const alpha = this.getAlpha(this.props.opacity);
    const background = this.getBackground(this.props.position, alpha);
    const style = this.getStyle(
      this.props.position,
      this.props.height,
      background,
    );
    return <div className={'StoryboardScrollHint'} style={style} />;
  }
}
